import { ActionTree } from 'vuex';
import { RootState } from '@/store/index';
import userApi from '_c/business/api/user';
import { State } from './state';


const actions: ActionTree<State, RootState> = {
  async getUserInfoLogin({ commit }): Promise<void> {
    userApi.getUserInfoLogin().then((res) => {
      commit('setUserInfo', {
        baseInfo: res.userInfoBase,
        accountInfo: res.userInfoAccount,
        cancelInfo: res.userInfoCancel,
      });
    });
  },
};

export default actions;
